import {BaseService} from "./BaseService";

import {config} from '../../Config';
import {USER_LOGOUT} from "../../Redux/Actions/Types";

class AuthService extends BaseService {
    constructor() {
        super();
    }

    get Url() { return super.Url + "/auth"; }

    Auth(xhr) {
        //Override to send without auth.
    }

    ForgotPassword(username) {
        return this.SendRequest(BaseService.GET, {
            username: username
        });
    }

    Login(username, password, saveSession) {
        let result = this.SendRequest(BaseService.POST, {
            username: username,
            password: password
        });

        result.then((x) => {
            if(x.success) {
                if(saveSession) {
                    BaseService.AUTH_TOKEN = x.jwt;
                    localStorage.setItem("storedAuthToken", x.jwt);

                    if(result.permissions) {
                        BaseService.PERMISSIONS = result.permissions;
                        localStorage.setItem("storedPermissions", JSON.stringify(result.permissions));
                    }
                }
            }
        }).catch((x) => x);

        return result;
    }

    Logout() {
        let result = this.SendRequest(BaseService.POST, {}, null, '/logout');

        return result.then((x) => {
            if(x.success) {
                BaseService.AUTH_TOKEN = '';
                BaseService.PERMISSIONS = [];

                localStorage.removeItem("storedAuthToken");
                localStorage.removeItem("storedPermissions");

                config.getStore().dispatch({type: USER_LOGOUT});
            }

            return result;
        });
    }
}

export const service = new AuthService();
